import {get,post} from '@/util/http';
import { Notification } from 'uiv'

const home = {
    state:{
        dateInfo: {},
        exhibition: [],
    },
    mutations:{
        setDateInfo(state, action){
            state.dateInfo = action
        },
        exhibitionList(state,action){
            state.exhibition = action 
        }
    },
    actions:{
        async dateinfo({commit},params){//倒计时
            const res = await get('/CifitSystem/api/home/cifitHome/dateinfo.jhtml',params);
            if(res.code == 200){
                commit('setDateInfo',res.data)
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async mianimg({},params){//首页主图
            const res = await get('/CifitSystem/api/home/cifitHome/mianimg.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async meetviewasmx({},params){//论坛研讨会预览表
            const res = await get('/CifitSystem/api/seminar/meeting/meetviewasmx.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async bigactivityasmx({},params){//查看更多重大活动列表
            const res = await get('/CifitSystem/api/home/cifitHome/bigactivityasmx.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async findhotel({},params){//首页酒店查询
            const res = await get('/CifitSystem/api/home/cifitHome/findhotel.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async hotelinfo({},params){//酒店具体详情信息
            const res = await get('/CifitSystem/api/home/cifitHome/hotelinfo.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async guestList({},params){//一级接口，查找列表
            const res = await get('/CifitSystem/api/home/cifitHome/guestList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async honorList({},params){//一级接口，查找列表
            const res = await get('/CifitSystem/api/cifit/guest/guestsList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async guestInfo({},params){//二级接口，查找详情
            const res = await get('/CifitSystem/api/home/cifitHome/guestInfo.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getStatistics({},params){//数据统计接口
            const res = await get('/CifitSystem/api/home/dataStatistics/getStatistics.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getexhibition({commit},params){//获取届数名称接口
            const res = await get('/CifitSystem/api/home/volunteer/getexhibition.jhtml',params);
            if(res.code == 200){
                // return res.data
                commit('exhibitionList', res.data)
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getvolunteerlist({},params){//获取志愿者列表
            const res = await get('/CifitSystem/api/home/volunteer/getvolunteerlist.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async areaList({},params){//网址首页展区内容，一级接口，List
            const res = await get('/CifitSystem/api/home/cifitHome/areaList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async areaInfo({},params){//网址首页展区内容，二级接口，查找ID对应的信息
            const res = await get('/CifitSystem/api/home/cifitHome/areaInfo.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async partnersList({},params){//合作伙伴与媒体
            const res = await get('/CifitSystem/api/home/cifitHome/partnersList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
    }
}

export default home


// WEBPACK FOOTER //
// ./src/store/modules/home.js